// extracted by mini-css-extract-plugin
export default {"actions":"Header_actions__6GKv5"};